import * as React from "react"

import Container from "../container/container"

import * as styles from "./intro.module.scss"

import hannah from "../../assets/about/hannah.jpg"

import Markdown from "react-markdown"

const AboutIntro = props => {
  return (
    <div className={styles.intro}>
      <Container>
        <div
          className={`d-flex align-items-center justify-content-between ${styles.intro__wrap}`}
        >
          <div className={styles.intro__section}>
            <h2>{props.data.Intro.Heading}</h2>
            <Markdown>{props.data.Intro.Body}</Markdown>
          </div>
          <div className={styles.intro__section}>
            <div className={styles.intro__section__image}>
              <div className={styles.intro__section__image__bg}></div>
              <img
                src={props.data.Intro.Image.publicURL}
                alt={props.data.Intro.Heading}
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default AboutIntro
